<template src="./IntegrateEpic.html">
</template>

<script>
import axios from 'axios'
import {mask} from "vue-the-mask"
import tooltips from '@/utilities/tooltips.js'
import coreAddressComponent from "@/components/core/CoreAddress"
import locationComponent from "@/components/Location"
import * as common from "@/common.js"
import * as epicApi from "@/epicApi.js"
import loading from '@/components/PageLoader'
import list from "@/components/core/CoreBMSMatchList"
import moment from 'moment'
import epicPolicyComponent from '@/components/core/CoreEPICPolicyHeader'
import ConfirmationModal from '@/components/global/ConfirmationModal'
import submitModal from '@/components/global/SubmitModal'
import contactEPICComponent from '@/components/core/CoreEPICContact'
import accountStructureTableComponent from '@/components/core/CoreAccountStructureTable'
import {instance, targets} from "@/constants";
import {required} from "vee-validate/dist/rules";

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
  components: {
    loading,
    list,
    'location-section': locationComponent,
    'core-address-section': coreAddressComponent,
    'core-epic-policy-header-section': epicPolicyComponent,
    'confirmation-modal': ConfirmationModal,
    'submit-modal': submitModal,
    'core-epic-contact-component': contactEPICComponent,
    'account-structure-table-component': accountStructureTableComponent
  },
  directives: {
    mask
  },
    computed: {

      requiresSICCode() {
        const acct = this.integrationData && this.integrationData.account;
        const country = acct ? acct.address1Country : null;
        return country === 'USA' || country === 'CAN';
      },

      sicCodeRules() {
        if (
          this.newClient === 'create' &&
          this.requiresSICCode &&
          this.integrationData &&
          this.integrationData.account
        ) {
          return (
            'required|epic_sic_code:' +
            this.integrationData.account.validValues.sicCodes
          );
        }
        return '';
      },

    required() {
      return required
    },
    targets() {
      return targets
    },
    linkedEpicTableFields() {
      return this.epicTableList.fields.filter(field => field.key !== 'checkbox');
    },
    fourHorsemen: function () {
      let array = [this.integrationData.account.administratorUserId,
        this.integrationData.account.primaryContactUserId,
        this.integrationData.account.primarySalesLeadUserId,
        this.integrationData.account.primaryServiceLeadUserId];
      //need to turn null into 0 because nulls are not passed into validator, we always need 4 elements
      for (let i in array) {
        if (array[i] == null)
          array[i] = 0;
      }
      return array;
    }
  },
  data() {
    return {
      clicked: false,
      instance: instance,
      showErrors: false,
      forceUpdate: 0,
      confirmUpdateMessage: [],
      statusMessages: [],
      bmsContactCopies: [],
      userBranches: [],
      submitLoading: false,
      selectedUserAgency: '',
      selectedPostal: '',
      selectedAccountName: '',
      isLoading: true,
      isContactLoading: false,
      selectedClientReady: false,
      validating: false,
      breadcrumbs: [
        {text: this.$t("Integrations"), to: {name: 'Integrations'}},
        {text: this.$t("Integration"), active: true}
      ],
      integrationData: {
        integration: null,
        account: null,
        contacts: [],
        opportunity: null,
        policy: {}
      },
      accountData: null,
      primarySalesLeadData: [],
      primaryServiceLeadData: [],
      adminData: [],
      primaryContactData: [],
      epicSicCodeData: [],
      epicNaicsCodeData: [],
      isTeamMemberButNotOfFourHorsemen: false,
      newClient: 'match',
      newContact: '',
      syncAccountEnabled: true,
      epicTableList: {
        mainHeader: this.$t("EpicClientAccount"),
        idProperty: "clientId",
        filterOn: ["accountName", "city", "stateOrProvinceCode", "clientLookupCode"],
        filter: null,
        dataArray: [],
        currentPage: 1,
	      totalPages: 1,
	      pageSize: 10,
	      totalRows: 0,
        initialValue: null,
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {key: "accountName", label: this.$t("Name"), sortable: true},
          {key: "city", label: this.$t("City"), sortable: true},
          {key: "stateOrProvinceCode", label: this.$t("StateProvince"), sortable: true},
          {key: "clientType", label: this.$t("ClientType"), sortable: true},
          {key: "status", label: this.$t("Status"), sortable: true},
          {key: "clientLookupCode", label: this.$t("ClientCode"), sortable: true},
          {key: "clientId", label: this.$t("PrimaryKey"), sortable: true}
        ]
      },
      primaryProducerData: [],
      primaryServicerData: [],
      accountCollapsed: false,
      additionalAccountLabel: this.$t("ShowMoreFields"),
      isBP: false,
      datePickerFormat: this.$t("DatePickerFormat"),
      datePickerMask: '##/##/20##',
      primaryContactValidationError: false,
      clientNotSelected: false,
      showClientList: false,
      showEpicSearchError: false,
      showInvalidMatchedIDErrorEpic: false,
      showDuplicateMatchedIDErrorEpic: false,
      newClientEnabled: true,
      coreProducerName: '',
      searchingProducer: false,
      coreServicerName: '',
      searchingServicer: false,
      defaultServicer: null,
      defaultProducer: null,
      structureOfSelectedAccount: [],
      userAgencies: [],
      duplicateUrl: null,
      latestClientSearchHadNoResults: false,
      isLinkedEpicClient: false
    }
  },
  created() {
  },
  watch: {
    "integrationData.account.agencyCode": function (newVal) {
      if (newVal) {
        if (this.newClient !== 'match') {
          this.integrationData.account.branchCode = null;
        }
        if (this.integrationData.userValidValues) {
          let agency = this.integrationData.userValidValues.structureTree.agencies.find(x => x.code === newVal);
          if (agency) {
            this.userBranches = agency.branches;

            if (agency.code === this.integrationData.userValidValues.defaultAgencyCode) {
              this.integrationData.account.branchCode = this.integrationData.userValidValues.defaultBranchCode;
            }
          } else {
            this.integrationData.account.agencyCode = this.integrationData.account.branchCode = null;
          }
        }
      }
    },

    requiresSICCode(isNowRequired) {
      if (
        this.integrationData &&
        this.integrationData.account &&
        !isNowRequired
      ) {
        this.integrationData.account.sicCode = null;
      }
    },

    newClient: function (newVal) {
      let app = this;
			if(newVal === 'create' && this.latestClientSearchHadNoResults){
				//workaround to make sure "no search results" doesn't result in hiding the search grid.
				this.newClient = 'match';
				return;
			}
      if (newVal === 'create') {
        let selectedVal = this.epicTableList.dataArray.find(x => x.isSelected);

        if (selectedVal)
          selectedVal.isSelected = false;

        if (this.integrationData.account)
          this.integrationData.account.matchedAccountID = 0;
        this.integrationData.syncAccount = true;
        this.syncAccountEnabled = false;
        this.integrationData.syncAccount = true;
        this.integrationData.syncContact = true;

        if (this.$route.params.din === app.instance.viu) {
          this.integrationData.syncPolicy = true;
        }
        this.structureOfSelectedAccount = []; // hide table items until user select account from client search table
      } else {
        this.syncAccountEnabled = true;
        this.showClientList = true;

        if (this.integrationData.account.matchedAccountID !== 0 && !this.latestClientSearchHadNoResults)
          this.newClientEnabled = false;
        else
          this.newClientEnabled = true;
      }
    },
		"integrationData.syncAccount": function (newVal) {
			if (newVal && this.integrationData.account.isPersonalLine)
				this.integrationData.syncContact = true;
		},
		"integrationData.syncContact": function (newVal) {
			if (newVal) {
				if (this.integrationData.account.isPersonalLine)
					this.integrationData.syncAccount = true;
				if (!this.integrationData.contacts || !this.integrationData.contacts.length) {
					this.integrationData.contacts = [{}];
				}
			}
		},
		"integrationData.account.matchedAccountID": function (newVal) {
			if (newVal === 0) {
				this.newClient = "create";
				this.setUserAgencyBranchDefault();
				this.setProducer(this.defaultProducer);
				this.setServicer(this.defaultServicer);
			}
			else this.newClientEnabled = this.latestClientSearchHadNoResults === true;

		},
    "integrationData.account.producerName": function (producerId) {
      this.setPolicyProducerFromAccount(producerId);
    }
  },
    mounted() {   
		this.datePickerPattern =  /(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d/g;

    this.loadPageData(false);
    if(this.$route.params.din === instance.enterprise){
      this.epicTableList.fields.push( {key: "producer.name", label: this.$t("Producer"), sortable: false});
    }
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.addEventListener('hashchange', this.hashChangeHandler);
    }
  },
  destroyed: function () {
    // fix for IE 11 .... why,  just why :(
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.removeEventListener('hashchange', this.hashChangeHandler);
    }
  },
    methods: {
      submitOkClick() {
      if (this.clicked) return; // Prevent multiple clicks

      this.clicked = true;
      if (this.primaryContactValidationError) {
        this.primaryContactValidationError = false;
        this.$refs.submitModal.hideSubmitModal();
      } else
          this.$router.push({ name: 'Integrations' });

      this.clicked = false; 

    },
    getEpicAccountPrimaryKey(integrationData) {
      if (!integrationData || !integrationData.account) {
        return null;
      }

      const destination = integrationData.epicDestination;
      const account = integrationData.account;
      const accountKey = destination === 'CA'
        ? account.epiccaPrimaryKey
        : account.epicusPrimaryKey;

      if (accountKey) {
        return accountKey;
      }

      if (!account.isPersonalLine || !integrationData.contacts) {
        return null;
      }

      const linkedContact = integrationData.contacts.find(contact => destination === 'CA'
        ? contact.epiccaAccountPK
        : contact.epicusAccountPK);

      if (!linkedContact) {
        return null;
      }

      return destination === 'CA'
        ? linkedContact.epiccaAccountPK
        : linkedContact.epicusAccountPK;
    },
    setLinkedEpicPolicyMode(integrationData) {
      integrationData.syncAccount = false;
      integrationData.syncContact = false;
      integrationData.syncPolicy = true;
    },
    onSubmit() {
      // The linked-client page contains account/contact fields for display
      // only. Their legacy create-client validation must not block policy
      // creation.
      if (this.isLinkedEpicClient) {
        this.setLinkedEpicPolicyMode(this.integrationData);
        this.showErrors = false;
        this.$bvModal.show('policyHeaderFields');
        return;
      }

      this.showErrors = true;
      let validationErrors = false;
      let hasPrimaryContact = false;
      if (this.integrationData.syncContact && this.integrationData.contacts) {
        this.integrationData.contacts.forEach((item, index) => {
          if ((item.hasValidationError || item.showEmailNotUniqueError) ||
              (this.integrationData.syncContact && item.newContact === 'match' && item.matchedContactID === 0))
            validationErrors = true;

          if (item.primaryContact === true)
            hasPrimaryContact = true;
        });
      }

      if (this.checkValidationErrors(hasPrimaryContact)) {
        validationErrors = true;
        if (this.hasPrimaryContactRequiredError(hasPrimaryContact)) {
          this.updateSubmitStatusMessage('Account', this.$t("PrimaryContactRequired"), false, true);
          this.primaryContactValidationError = true;
          this.$refs.submitModal.showSubmitModal();
        }
      }

      if (validationErrors)
        return;

      if (this.integrationData.syncPolicy) {
        this.$bvModal.show('policyHeaderFields');
      } else {
        this.policySubmit();
      }
    },
    setIssuingLocationFromState() {
      const account = this.integrationData.account;
      let state = account && account.address1StateOrProvince;

      if (account && account.isPersonalLine === true) {
        const primaryContact = (this.integrationData.contacts || [])
          .find(contact => contact.primaryContact === true);
        state = primaryContact && primaryContact.address1StateOrProvince;
      }

      this.integrationData.policy.issuingLocationCode = state || null;
    },
    checkValidationErrors(hasPrimaryContact) {
      return this.hasClientNotSelectedError() || this.hasMustSyncSomethingError() || this.hasPrimaryContactRequiredError(hasPrimaryContact) || this.showSelectClient();
    },
    hasClientNotSelectedError() {
      return this.integrationData.syncAccount && this.newClient === 'match' && this.integrationData.account.matchedAccountID == 0;
    },
    hasMustSyncSomethingError() {
      return !this.integrationData.syncAccount && !this.integrationData.syncPolicy && !this.integrationData.syncContact;
    },
    hasPrimaryContactRequiredError(hasPrimaryContact) {
      let retVal = false;

      if (!this.isLinkedEpicClient && this.newClient === 'create' && hasPrimaryContact === false)
        retVal = true;

      return retVal;
    },
    showSelectClient() {
      return ((this.integrationData.syncContact || this.integrationData.syncPolicy) && this.newClient === 'match') && (!this.integrationData.account || this.integrationData.account.matchedAccountID === 0);
    },
    // Submit Request(s)
    cancelSubmitRequest() {
      // Don't think we need this
    },
    async confirmSubmitRequest() {
      let app = this;

      // A primary-key-linked client is already owned by Epic.  This flow only
      // creates the policy shell; it must never update the account or contacts.
      if (this.isLinkedEpicClient) {
        this.setLinkedEpicPolicyMode(this.integrationData);
      }

      this.statusMessages = [];
      this.$bvModal.hide('policyHeaderFields');
      this.$refs.submitModal.showSubmitModal();
      this.submitLoading = true;
      this.integrationData.updateStatus = "Success";
      this.integrationData.updateAccountId = this.integrationData.account.matchedAccountID;
      this.integrationData.updateContactId = 0;
      this.integrationData.updatePolicyId = 0;

      // grab all create/match with the exception of the primary contact. That one is uploaded as part of the account creation.
      let contacts = null;
      if (this.integrationData.contacts) {
        contacts = this.integrationData.contacts.filter(x => x.newContact === 'create' || x.newContact === 'match');
      }

      try {
        const result = await this.submitAccount(); 

        if (result) {
          app.integrationData.updateAccountId = result;

          if (app.integrationData.houseHold && app.integrationData.houseHold.householdID != null) {
            this.updateHouseholdEpicId(app.integrationData.houseHold.householdID, result);
          }
        } else {
          app.integrationData.updateAccountId = app.integrationData.account.matchedAccountID;
        }

        if (contacts) {
          for (const item of contacts ) {
            if ((!item.primaryContact || (item.newContact === 'create' && this.newClient === 'match')) || (app.integrationData.dynamicsInstanceName === instance.viu && !item.isPrimary)) {
              await this.submitContact(item); 
            }
          }
        }

        await this.submitPolicy();

        if (this.integrationData.updateStatus === 'Failed') {
          return this.submitComplete("Failed");
        }
        return this.submitComplete("Success");
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
        this.submitComplete("Failed");
      }
    },
    submitComplete(status) {
      if (status === 'Success') {
        return this.submitCOREUpdateStatus(status).then((response) => {
          // done
          this.submitLoading = false;
        }).catch(error => {
          // error updating status
          this.submitLoading = false;
        });
      } else {
        this.submitLoading = false;

      }
    },
    submitAccount() {
      let postData = {
        account: this.integrationData.account,
        primaryContact: this.integrationData.contacts ? this.integrationData.contacts.filter(x => x.primaryContact === true)[0] : null,
        householdId: this.integrationData.houseHold ? this.integrationData.houseHold.householdId : null
      };
      if (this.integrationData.syncAccount) {
        this.updateSubmitStatusMessage('account', this.$t("SubmittingAccount"), true, false);
        return epicApi.submitAccountToEpic(this.integrationData.account.accountID, this.integrationData.epicDestination, postData, this.submitAccountCompleted, this.submitAccountError);
      } else {
        return Promise.resolve(); // TODO: return matched account id
      }
    },
    updateHouseholdEpicId(dynamicsHouseholdId, epicAccountId) {
      return epicApi.updateHousehold(dynamicsHouseholdId, this.integrationData.epicDestination, epicAccountId, this.integrationData.dynamicsInstanceName)
    },
    submitAccountCompleted(response){
      let accountId = response.data;
      this.updateSubmitStatusMessage('account', this.$t("AccountSubmitted", {0: this.integrationData.account.name}), false, false);

      let primaryContact = this.integrationData.contacts.filter(x => (x.newContact === 'create' || x.newContact === 'match') && x.primaryContact === true);
      if (primaryContact && primaryContact.length > 0)
        this.updateSubmitStatusMessage(`contact${primaryContact[0].contactID}`, this.$t("ContactUpdated", {0: primaryContact[0].lastName + ", " + primaryContact[0].firstName}), false, false);
      return accountId;
    },
    submitAccountError(error){
      if (error.response && error.response.data) {
        if (error.response.data.accountId) {
          this.updateSubmitStatusMessage('account', this.$t("AccountSubmitted", {0: this.integrationData.account.name}), false, false);
          console.log("Account submitted " + error.response.data.accountId);

          let primaryContact = this.integrationData.contacts.filter(x => (x.newContact === 'create' || x.newContact === 'match') && x.primaryContact === true);
          if (primaryContact && primaryContact.length > 0)
            this.updateSubmitStatusMessage(`contact${primaryContact[0].contactID}`, this.$t("PrimaryContactFailedUpdate", {0: primaryContact[0].lastName + ", " + primaryContact[0].firstName}), false, true);

          this.integrationData.updateStatus = "Failed";
          if (error.response.data.error.error) {
            console.log(this.$t("ErrorOccurred", {0: error.response.data.error.error}));
            throw new Error(error.response.data.error);
          } else {
            console.log(this.$t("ErrorOccurred", {0: error.response.data.error}));
          }
        } else
          console.log(this.$t("ErrorOccurred", {0: error.response.data.error}));
      } else {
        console.log(this.$t("ErrorOccurred", {0: error}));
      }
      this.updateSubmitStatusMessage('account', this.$t("AccountSubmitFailed"), false, true);
      this.integrationData.updateStatus = "Failed";
      throw new Error(error);
    },
    async submitContact(contact) {
      if (this.integrationData.syncContact && this.integrationData.updateAccountId !== 0) {
        this.updateSubmitStatusMessage(`contact${contact.contactID}`, this.$t("SubmittingContact", {0: contact.lastName + ", " + contact.firstName}), true, false);
        var response = await epicApi.submitContactToEpic(contact.contactID, this.integrationData.updateAccountId, this.integrationData.epicDestination, contact, this.submitContactCompleted, this.submitContactError);
        console.log(response)
        if (response.response.status == 200) {
          this.submitContactCompleted(contact, response)
        } else if (repsonse.response.status >= 500 || repsonse.response.status >= 400) {
          this.submitContactError(contact, response.error)
        }
        return;
      } else {
        return Promise.resolve();
      }
    },
    submitContactCompleted(contact, response){
      let contactId = response.data;
      this.updateSubmitStatusMessage(`contact${contact.contactID}`, this.$t("ContactUpdated", {0: contact.lastName + ", " + contact.firstName}), false, false);
      console.log("Contact submitted " + contactId);
      return response.data;
    },
    submitContactError(contact, error){
      this.integrationData.updateStatus = "Failed";
      this.updateSubmitStatusMessage(`contact${contact.contactID}`, this.$t("ContactFailedUpdate", {0: contact.lastName + ", " + contact.firstName}), false, true);
      console.log("Failed to update contact " + contact.firstName + contact.lastName);
      if (error.response && error.response.data && error.response.data.error) {
        console.log(this.$t("ErrorOccurred", {0: error.response.data.error}));
      } else {
        console.log(this.$t("ErrorOccurred", {0: error}));
      }
      throw new Error(error);
    },
    async submitPolicy(response) {
      if (this.integrationData.policy.effectiveDate)
        this.integrationData.policy.timezoneOffset = this.integrationData.policy.effectiveDate.getTimezoneOffset();
      else if (this.integrationData.policy.expirationDate)
        this.integrationData.policy.timezoneOffset = this.integrationData.policy.expirationDate.getTimezoneOffset();

      if (this.integrationData.syncPolicy && this.integrationData.updateAccountId !== 0) {
        this.updateSubmitStatusMessage('policy', this.$t("SubmittingPolicy"), true, false);
        let policyType =  this.integrationData.policy.validValues.policyTypes.find(x => x.id === this.integrationData.policy.policyTypeId).name;
        this.integrationData.policy.validValues = {};
        return epicApi.submitPolicyToEpic(this.integrationData.updateAccountId, this.integrationData.opportunityID, this.integrationData.epicDestination, this.integrationData.policy, policyType, this.submitPolicyCompleted, this.submitPolicyError);
      } else {
        return Promise.resolve();
      }
    },
    submitPolicyCompleted(policyType, response){
      let policyId = response.data.policyId;
      if (response.data.message !== undefined && response.data.message !== null && response.data.message.length > 0) {
        this.updateSubmitStatusMessage('policywarning', this.$t(response.data.message), false, false);
      }

      this.updateSubmitStatusMessage('policy', this.$t("PolicySubmitted", {0: policyType}), false, false);

      console.log("Policy submitted " + policyId);
      return policyId;
    },
    submitPolicyError(error){
      this.integrationData.updateStatus = "Failed";
      let policyType = this.integrationData.policy.validValues.policyTypes.find(x => x.id === this.integrationData.policy.policyTypeId).name;
      this.updateSubmitStatusMessage('policy', this.$t("PolicyFailed", {0: policyType}), false, true);

      if (error.response && error.response.data && error.response.data.error) {
        console.log(this.$t("ErrorOccurred", {0: error.response.data.error}));
      } else {
        console.log(this.$t("ErrorOccurred", {0: error}));
      }
      throw new Error(error);
    },
    submitCOREUpdateStatus(status) {
      this.updateSubmitStatusMessage('core', this.$t("UpdatingIntegrationRequest"), true, false);
      let statusMessage = "";
      if (status === 'Success')
        statusMessage = this.$t("Success");
      else if (status === 'Failed')
        statusMessage = this.$t("Failed")

      return epicApi.submitUpdateCOREStatus(this.integrationData.integrationID, status, statusMessage, this.integrationData.dynamicsInstanceName, this.integrationData.targetSystem, this.submitCOREUpdateStatusCompleted, this.submitCOREUpdateStatusError);
    },
    submitCOREUpdateStatusCompleted(statusMessage, response){
      this.updateSubmitStatusMessage('core', this.$t("IntegrationRequestClosed", {0: statusMessage}), false, false);
      return response.data;
    },
    submitCOREUpdateStatusError(statusMessage, error){
      this.updateSubmitStatusMessage('core', this.$t("ErrorClosingRequest", {0: statusMessage}), false, true);
      console.log(this.$t("ErrorOccurred", {0: error}))
    },
    policySubmit() {
      this.setConfirmMessage();
      this.$refs.confirmSubmit.showConfirmationModalManual(this.confirmUpdateMessage, this.confirmSubmitRequest, this.cancelSubmitRequest, null);
    },
    setConfirmMessage() {
      const h = this.$createElement;
      let app = this;
      let vNodes = [];

      vNodes.push(h('p', this.$t("FollowingWillBePerformed")));

      if (this.integrationData.syncAccount) {
        let account;
        if (this.epicTableList.dataArray) {
          account = this.epicTableList.dataArray.find(x => x.clientId == this.integrationData.account.matchedAccountID);
        }

        if (this.integrationData.account.isPersonalLine !== true) {
          vNodes.push(h('div', this.newClient === 'match' ? this.$t("CoreAccountMatched", {0: account.accountName}) : this.$t("NewClientCreatedForCore", {0: this.integrationData.account.name})));
        } else if (this.integrationData.account.isPersonalLine && this.integrationData.contacts.length > 0) {
          vNodes.push(h('div', this.newClient === 'match' ? this.$t("CoreContactMatchedClient", {0: account.accountName}) : this.$t("NewPersonalLineCreated", {0: this.integrationData.contacts[0].fullName})));
        }
      }

      // Will need to be rewritten for multiple contacts
      if (this.integrationData.syncContact && this.integrationData.contacts) {
        vNodes.push(h('div', ''));
        this.integrationData.contacts.forEach((item, index) => {
          if (item.newContact && item.newContact !== 'donotsync' && app.bmsContactCopies.length > 0) {
            let bmsContact = app.bmsContactCopies[0].find(x => x.contactID === item.matchedContactID);

            if (this.integrationData.account.isPersonalLine != true) {
              vNodes.push(h('div', item.newContact == 'match' ? this.$t("CoreContactMatchedContact", {
                0: item.firstName + " " + item.lastName,
                1: bmsContact.firstName + " " + bmsContact.lastName
              }) : this.$t("NewContactCreatedForCore", {0: item.firstName + " " + item.lastName})));
            }
          } else {
            if (item.newContact == 'create') {
              if (this.integrationData.account.isPersonalLine != true) {
                vNodes.push(h('div', this.$t("NewContactCreatedForCore", {0: item.firstName + " " + item.lastName})));
              }
            }
          }
        });
      }

      if (this.integrationData.syncPolicy) {
        vNodes.push(h('div', this.$t("NewPolicyHeader")));
      }

      this.confirmUpdateMessage = vNodes;
    },
    updateSubmitStatusMessage(id, text, isLoading, isError) {
      let message = this.statusMessages.find(x => x.id === id);
      if (message) {
        message.text = text;
        message.isLoading = isLoading;
        message.isError = isError;
      } else {
        this.statusMessages.push({id: id, text: text, isLoading: isLoading, isError: isError});
      }
    },
    loadPageData(isRefresh) {
      // load CoreIntegration record
      this.isLoading = true;
      return epicApi.loadEpicIntegration(this.$route.params.integrationId, this.$route.params.din, this.loadPageDataComplete, this.loadPageDataError);
    },
    loadPageDataComplete(response){
      let app = this;
      if (response.data) {
        app.integrationData = response.data;

        // default to having a primary contact
        if (app.integrationData.contacts != null && app.integrationData.dynamicsInstanceName === instance.viu) {
          app.integrationData.contacts[0].isPrimary = true;
        }

        app.userAgencies = app.integrationData.userValidValues.structureTree.agencies;

        app.breadcrumbs[1].text = app.integrationData.name;
        if (app.integrationData.account.administratorUserId === 0) {
          app.integrationData.account.administratorUserId = null;
        }
        if (app.integrationData.account.primaryContactUserId === 0) {
          app.integrationData.account.primaryContactUserId = null;
        }
        if (app.integrationData.account.producerName === 0) {
          app.integrationData.account.producerName = null;
        } else
          app.coreProducerName = app.integrationData.account.producerName;
        if (app.integrationData.account.servicer.id === 0) {
          app.integrationData.account.servicer.id = null;
        } else
          app.coreServicerName = app.integrationData.account.servicer.id;
        if (app.integrationData.account.primaryServiceLeadUserId === 0) {
          app.integrationData.account.primaryServiceLeadUserId = null;
        }

        this.defaultProducer = {
          id: app.integrationData.account.producerName,
          name: app.integrationData.account.producerNameName
        };
        if (this.defaultProducer.id && this.defaultProducer.name) {
          this.primaryProducerData = common.buildDefaultOption(this.defaultProducer.id, this.defaultProducer.name);
        }

        this.defaultServicer = common.safeClone(app.integrationData.account.servicer);
        if (this.defaultServicer.id && this.defaultServicer.name) {
          this.primaryServicerData = common.buildDefaultOption(this.defaultServicer.id, this.defaultServicer.name);
        }

        this.loadAccounts(true);
        this.showClientList = false;
        //modal is now shown inside loadAccounts if necessary or skipped if not.
        this.setDefaults();
      }
    },
    loadPageDataError(error){
      this.isLoading = false;
      console.log('Error occured:' + error)
    },
    formatDollar(value) {
      if (this.$i18n.locale === 'fr') {
        const formatter = new Intl.NumberFormat('fr-CA', {
          style: 'currency',
          currency: 'CAD',
          minimumFractionDigits: 2
        });

        return formatter.format(value);
      } else {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2
        });

        return formatter.format(value);
      }
    },
    submitPolicyHeader() {

    },
    loadAccounts(isRefresh) {
      this.isLoading = true;
      let app = this;

      const epicPrimaryKey = this.getEpicAccountPrimaryKey(app.integrationData);
      app.isLoading = true;

      if (epicPrimaryKey) {
        return epicApi.getEpicAccountById(epicPrimaryKey, app.integrationData.epicDestination, this.getEpicAccountByPKCompleted, this.getEpicAccountByPKError);
      } else {
        // Searching Epic and manually linking an unlinked Core client is no
        // longer supported.  An unlinked request always creates a new client.
        this.createNewClient();
        app.isLoading = false;
      }
    },
    getEpicAccountByPKCompleted(epicPrimaryKey, response){
      let app = this;
      app.isLoading = false;
      app.epicTableList.dataArray = response.data.results;
      app.epicTableList.totalPages = response.data.pageCount; //should be 1
      app.epicTableList.totalRows = response.data.results.length;
      app.epicTableList.currentPage = response.data.pageNumber; // should be 1
      //We have a prematched epic account id that is valid in epic, so skip the client search modal &
      // select it.
      if (response.data.results.length > 0) {
        app.isLinkedEpicClient = true;
        app.newClient = 'match';
        this.matchedAccount(epicPrimaryKey);
        this.setLinkedEpicPolicyMode(app.integrationData);
        this.setIssuingLocationFromState();
        app.epicTableList.initialValue = epicPrimaryKey; //has to come after matchedAccount() or will get cleared.

      } else {
        // Do not fall back to the retired search/match flow for a stale key.
        this.showInvalidMatchedIDErrorEpic = true;
      }
      app.isLoading = false;

      return (response.data.results);
    },
    getEpicAccountByPKError(error){
      let app = this;
      app.isLoading = false;
      app.$router.push({ name: 'Integrations' });
      return []
    },
	  refreshEpicAccounts(pagenumber=1) {
		  if (this.selectedUserAgency && (this.selectedAccountName || this.selectedPostal)) {
			  this.showEpicSearchError = false;
			  this.showInvalidMatchedIDErrorEpic = false;
			  this.showDuplicateMatchedIDErrorEpic = false;
				this.latestClientSearchHadNoResults = false;
			  this.duplicateUrl = null;
			  let app = this;
			  app.isLoading = true;
        return epicApi.epicAccountSearch(this.selectedPostal, this.selectedUserAgency, this.selectedAccountName, this.integrationData.epicDestination, pagenumber, this.epicAccountSearchCompleted, this.epicAccountSearchError);
		  } else {
			  this.showEpicSearchError = true;
		  }
	  },
    epicAccountSearchCompleted(response){
      let app = this;
      app.isLoading = false;
      app.epicTableList.dataArray = response.data.results;
      app.epicTableList.totalPages = response.data.pageCount;
      if(response.data.pageNumber === response.data.pageCount){
        app.epicTableList.totalRows = ((response.data.pageCount - 1) * app.epicTableList.pageSize) + response.data.results.length;
      }else{
        //approximate.  we don't know exact.
        app.epicTableList.totalRows = response.data.pageCount * app.epicTableList.pageSize;
      }
      app.epicTableList.currentPage = response.data.pageNumber;
      if(response.data.results.length === 0){
        //This is to get around the hard-wiring of enabling the new client radiobutton to having no match id when not in modal. If we
        //clear the matchid before we run the search, then it hides the search results table.  We need the user to see that there were no
        //search results so they can either do another search or actively choose create new client.
        this.latestClientSearchHadNoResults = true;
        this.newClientEnabled = true;
        this.matchedAccount(0);
      }
    },
    epicAccountSearchError(error){
      this.isLoading = false;
    },
	  accountPageChanged(newval) {
		  this.refreshEpicAccounts(newval);
	  },
    formatDate(date) {
      return moment.utc(date).format(this.$t('DateFormat'))
    },
    matchedAccount(accountID) {
      let app = this;
      //selectedClientReady is necessary because when the user selects a client from the list, the system calls out
      //to load contacts, and the response is sometimes slow.  If the user tries to click "OK" (ie match) before the contacts have
      //returned, the app won't be able to validate that the selected client isn't already tied to another account.
      //So we need to keep the OK button disabled until that contact query comes back and the validation can be triggered
      //properly.
      app.selectedClientReady = false;
      if (accountID !== 0) {
        app.validating = true;
      }
      app.showDuplicateMatchedIDErrorEpic = false;
      this.duplicateUrl = null;
      this.initialValue = null;
      if (this.integrationData.account)
        this.integrationData.account.matchedAccountID = accountID;

      if (accountID !== 0) {
        app.isContactLoading = true;
        app.integrationData.account.matchedAccountID = accountID;

        this.epicTableList.initialValue = null;
        let selectedAccount = this.epicTableList.dataArray.find(x => x.clientId === accountID);
        if (selectedAccount) {
          app.newClient = 'match';
          app.integrationData.account.agencyCode = selectedAccount.structures[0].agencyCode;
          app.integrationData.account.branchCode = selectedAccount.structures[0].branchCode;
          //if there are agency defined categories on the account, see if any are SP tags.
          //if so, attach profit center and ADC.
          if(selectedAccount.strategicPartnerDefaultProfitCenter !== null && selectedAccount.strategicPartnerDefaultProfitCenter !== undefined){
            app.integrationData.policy.profitCenterCode = selectedAccount.strategicPartnerDefaultProfitCenter;
          }
          if(selectedAccount.referralCompanyName !== null && selectedAccount.referralCompanyName !== undefined){
            app.integrationData.policy.referralCompanyName = selectedAccount.referralCompanyName;
          }
          app.integrationData.policy.agencyDefinedCategory = selectedAccount.strategicPartnerCategory;

          let producer = selectedAccount.producer;
          let servicer = selectedAccount.servicer;
          if (producer.id) {
            this.setProducer(producer);
          } else {
            this.setProducer(this.defaultProducer);
          }

          if (servicer.id) {
            this.setServicer(servicer);
          } else {
            this.setServicer(this.defaultServicer);
          }

          this.structureOfSelectedAccount = selectedAccount.structures;
          //this.clearPolicyStructureSelections(); //a user can close policy popup and choose diffrent account to match, we need a fresh state
        }
        if (this.isLinkedEpicClient) {
          // Contact matching is intentionally retired for linked requests.
          app.isContactLoading = false;
          app.selectedClientReady = true;
          app.validating = false;
        } else {
          epicApi.getEpicContactsByAccountId(accountID, this.integrationData.epicDestination, this.getEpicContactsByIdCompleted, this.getEpicContactsByIdError)
        }
      } else {
        app.newContact = null;
      }
    },
    getEpicContactsByIdCompleted(response){
      let app = this;
      app.bmsContactCopies = [];
      if (app.integrationData.contacts) {
        app.integrationData.contacts.forEach((item, index) => {
          let contactCopy = JSON.parse(JSON.stringify(response.data));
          app.bmsContactCopies.push(JSON.parse(JSON.stringify(contactCopy)));
        });
      }
      app.isContactLoading = false;
      if (this.integrationData.account.isPersonalLine) {

        let contactid = app.getContactId(app.bmsContactCopies);
        if (contactid === null) { //if no contacts, we can't query dynamics for it.
          app.finishClientValidationEpic(null);
          return;
        }
        epicApi.getDynamicsContactByEpicKey(app.integrationData.epicDestination, contactid, app.integrationData.dynamicsInstanceName, app.finishClientValidationEpic)
      } else {
        epicApi.getDynamicsAccountByEpicKey(app.integrationData.epicDestination, app.integrationData.account.matchedAccountID, app.integrationData.dynamicsInstanceName, app.finishClientValidationEpic);
      }
    },
    getEpicContactsByIdError(error){
      app.isContactLoading = false;
      return [];
    },
    onSearchPrimaryProducer(search, loading) {
      if (!search) {
        return;
      }
      this.searchingProducer = true;
      loading(true);
      epicApi.getEpicAccountProducers(loading, search, this.integrationData.account.producerName, this.integrationData.epicDestination, this.primaryProducerDataGetSet);
    },
    primaryProducerDataGetSet(apiData) {
      if (apiData) {
        this.primaryProducerData = apiData;
        this.searchingProducer = false;
      } else
        return this.primaryProducerData;
    },
    onSearchPrimaryServicer(search, loading) {
      if (!search) {
        return;
      }
      this.searchingServicer = true;
      loading(true);
      epicApi.getEpicAccountServicers(loading, search, this.integrationData.account.servicer.id, this.integrationData.epicDestination, this.primaryServicerDataGetSet);
    },
    primaryServicerDataGetSet(apiData) {
      if (apiData) {
        this.primaryServicerData = apiData;
        this.searchingServicer = false;
      } else
        return this.primaryServicerData;
    },
    onSearchEpicSicCode(search, loading) {
      if (!search) {
        return;
      }
      epicApi.getEpicSicCodes(loading, search, this.integrationData.account.sicCode, this.integrationData.epicDestination, this.sicCodeDataGetSet);
    },
    onSearchEpicNaicsCode(search, loading) {
      if (!search) {
        return;
      }
      epicApi.getEpicNaicsCodes(loading, search, this.integrationData.account.naicsCode, this.integrationData.epicDestination, this.naicsCodeDataGetSet);
    },
    sicCodeDataGetSet(apiData) {
      if (apiData)
        this.epicSicCodeData = apiData;
      else
        return this.epicSicCodeData;
    },
    naicsCodeDataGetSet(apiData) {
      if (apiData)
        this.epicNaicsCodeData = apiData;
      else
        return this.epicNaicsCodeData;
    },
    showTeamError() {
      if (this.disableTeamInfo()) //do not show if the whole team-info component is disabled
        return false;

      if (this.fourHorsemen.indexOf(0) > -1 || this.fourHorsemen.indexOf('0') > -1) //do not show error until all team members selected
        return false;

      return this.fourHorsemen.indexOf(this.integrationData.account.bpUserId) === -1;
    },
    disableTeamInfo() {
      return this.isTeamMemberButNotOfFourHorsemen;
    },
    primaryProducerToolTip() {
      return tooltips.originalCoreToolTip(this.coreProducerName);
    },
    primaryServicerToolTip() {
      return tooltips.originalCoreToolTip(this.coreServicerName);
    },
    sicCodeToolTip() {
      return tooltips.originalCoreToolTip(this.integrationData.account.sicCode);
    },
    naicsCodeToolTip() {
      return tooltips.originalCoreToolTip(this.integrationData.account.naicsCode);
    },
    showPolicyModal() {
      this.$bvModal.show('policyHeaderFields');
    },
    setDefaults() {
      this.integrationData.policy.renewalDate = '';
      if (this.integrationData.policy.effectiveDate) {
        // Replace T with Z in the .NET timestamp string to force UTC parsing instead of local parsing
        // This way the time matches what you get when manually selecting a date in the UI
        this.integrationData.policy.effectiveDate = new Date(this.integrationData.policy.effectiveDate.replace("T", "Z"));
        if (isNaN(this.integrationData.policy.effectiveDate))
          this.integrationData.policy.effectiveDate = null;
      }
      if (this.integrationData.policy.effectiveDate === null)
        this.integrationData.policy.effectiveDate = '';
      this.integrationData.policy.commissionDate = '';
      if (this.integrationData.policy.lineCommission)
        this.integrationData.policy.displayedLineCommission = this.integrationData.policy.lineCommission.toString();

      //The agency might already be set, don't override it with default if it was meaningfully selected.
      if (common.IsNotPopulated(this.selectedUserAgency)) {
        this.selectedUserAgency = this.integrationData.userValidValues.defaultAgencyCode; //for account search popup and embedded table
      }
    },
    setUserAgencyBranchDefault() {
      if (this.integrationData.userValidValues)
        this.integrationData.account.agencyCode = this.integrationData.userValidValues.defaultAgencyCode;
      if (this.integrationData.userValidValues && this.integrationData.account.agencyCode)
        this.integrationData.account.branchCode = this.integrationData.userValidValues.defaultBranchCode;
      else
        this.integrationData.account.branchCode = null; //clear branch when we switch to "Yes, Create a new Client" but we don't have defaultAgencyCode
    },
    setProducer(producer) {
      this.primaryProducerData = common.buildDefaultOption(producer.id, producer.name);
      this.integrationData.account.producerName = producer.id; //producerId
      this.integrationData.account.producerNameName = producer.name;
    },
    setPolicyProducerFromAccount(producerId) {
      if (this.newClient !== 'create' || !this.integrationData.policy) {
        return;
      }

      if (!producerId) {
        this.integrationData.account.producerNameName = null;
        this.integrationData.policy.producer = null;
        return;
      }

      const producer = this.primaryProducerData.find(option => option.id === producerId);
      if (!producer) {
        return;
      }

      this.integrationData.account.producerNameName = producer.name;

      const currentPolicyProducer = this.integrationData.policy.producer;
      if (currentPolicyProducer && currentPolicyProducer.id === producer.id &&
          typeof currentPolicyProducer.isCommissionable === 'boolean') {
        currentPolicyProducer.name = producer.name;
        return;
      }

      this.integrationData.policy.producer = null;
      epicApi.getEpicPolicyProducer(
        producer.id,
        producer.name,
        this.integrationData.epicDestination,
        this.integrationData.businessUnitName,
        this.integrationData.dynamicsInstanceName,
        this.setPolicyProducerFromAccountCompleted);
    },
    setPolicyProducerFromAccountCompleted(producerId, producer) {
      if (this.newClient !== 'create' ||
          this.integrationData.account.producerName !== producerId) {
        return;
      }

      this.integrationData.policy.producer = producer
        ? common.safeClone(producer)
        : null;
    },
    setServicer(servicer) {
      this.primaryServicerData = common.buildDefaultOption(servicer.id, servicer.name);
      this.integrationData.account.servicer = common.safeClone(servicer);
    },
    checkEmails(contactID) {
      let email = this.integrationData.contacts.find(x => x.contactID === contactID).email;
      if (email) {
        let numMatches = this.integrationData.contacts.filter(x => x.email === email && (x.newContact && x.newContact === 'create')).length;
        if (numMatches > 1) {
          this.integrationData.contacts.forEach((item, index) => {
            if (item.email === email && (item.newContact && item.newContact === 'create'))
              item.showEmailNotUniqueError = true;
            else
              item.showEmailNotUniqueError = false;
          });
        } else {
          this.integrationData.contacts.forEach((item, index) => {
            item.showEmailNotUniqueError = false;
          });
        }
      }
      this.forceUpdate += 1;
    },
    primaryContactChanged(contactID) {
      this.integrationData.contacts.forEach((item, index) => {
        if (item.primaryContact === true && item.contactID !== contactID)
          item.primaryContact = false;
      });
    },
    getContactId(contactCopies) {
      //This is recursive because sometimes (or always, not sure) the actual element is nested.
      //Instead of hardcoding to copies[0][0] I want to make this find copy where it can.
      if (contactCopies !== null && contactCopies.length > 0) {
        let copy = contactCopies[0];
        if (copy instanceof Array) {
          return this.getContactId(copy);
        }
        //BP and Epic contacts have different casing.
        if (copy.contactId !== undefined) {
          return copy.contactId;
        }
        if (copy.contactID !== undefined) {
          return copy.contactID;
        }
      }
      return null;
    },
    selectClient() {
      if (!this.integrationData.account || this.integrationData.account.matchedAccountID == 0)
        this.clientNotSelected = true;
      else {
        this.clientNotSelected = false;
        this.newClient = "match";
        this.showClientList = true;
      }
    },
    finishClientValidationEpic(existingAccount) {
      if (existingAccount !== null && existingAccount instanceof Object && (this.isMismatchedContact(existingAccount)) || this.isMismatchedAccount(existingAccount)) {
        this.showDuplicateMatchedIDErrorEpic = true;
        this.duplicateUrl = existingAccount.dynamicsUrl;
      } else {
        this.selectedClientReady = true;
      }
      this.validating = false;
    },
    isMismatchedContact(existing) {
      //no contact exists, we're good
      if (existing === undefined || existing.contactID === undefined) {
        return false;
      }

      if (this.integrationData.houseHold && this.integrationData.houseHold.householdID != null) {
        let matchedContact = this.integrationData.contacts.filter(x => (x.contactID === existing.contactID));
        if (matchedContact && matchedContact.length === 0)
          return true;
      }
      else if (existing.contactID !== this.integrationData.contacts[0].contactID) {
        return true;
      }

      return false;
    },
    isMismatchedAccount(existing) {
      if (existing === undefined || existing.accountID === undefined) {
        return false;
      }
      if (existing.accountID !== this.integrationData.account.accountID) {
        return true;
      }
      return false;
    },
    createNewClient() {
      this.newClient = "create";
      this.showClientList = false;
    },
    mapKeydownOverride(map, vselect) {
      map[13] = e => this.suppressEnterWhenLoading(e, vselect);
      return map;
    },
    suppressEnterWhenLoading(e, vselect) {
      if (this.searchingProducer || this.searchingServicer) {
        e.preventDefault();
      } else {
        e.preventDefault();
        return vselect.typeAheadSelect();
      }
    }
  }
}
</script>
